import { Button, DataTable, DataTableRef, FlexContainer } from '@uni-space/uni-components';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParcelSettingsTable } from '../model/useParcelSettingsTable';
import CancelParcel from './CancelParcel';
import { getAllParcels } from '../api';

export default function Parcels() {
  const { columns, filters, ModalComponent } = useParcelSettingsTable();
  const [isOpenCancelParcelModel, setIsOpenCancelParcelModal] = useState<boolean>(false);
  const { i18n } = useTranslation();
  const tableRef = useRef<DataTableRef>(null);
  const { t } = useTranslation();

  const handleRefetch = async () => {
    tableRef.current?.refetchData();
  };

  const handleOpenCancelParcelModal = () => {
    setIsOpenCancelParcelModal(true);
  };

  return (
    <>
      {ModalComponent()}
      <CancelParcel
        isOpen={isOpenCancelParcelModel}
        onClose={() => setIsOpenCancelParcelModal(false)}
        onRefetch={handleRefetch}
      />
      <DataTable
        renderControls={
          <FlexContainer gap="16px">
            <Button onClick={handleOpenCancelParcelModal} size="s">
              {t('cancelParcel')}
            </Button>
          </FlexContainer>
        }
        ref={tableRef}
        columns={columns}
        filters={filters}
        onFetch={getAllParcels}
        lang={i18n.language}
        height="calc(100vh - 220px)"
      />
    </>
  );
}
